import script from "./Parametros.vue?vue&type=script&setup=true&lang=js"
export * from "./Parametros.vue?vue&type=script&setup=true&lang=js"

import "./Parametros.vue?vue&type=style&index=0&id=5c13e684&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c13e684"]])

export default __exports__